import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getGeneralAPIRequest, getBessStatusBySystemId } from '../../utils/apiCommonMethods';

export const fetchBessStatusBySystemId = createAsyncThunk(
  'bess/fetchStatus',
  async ({ msSessionInfo, systemIds }, { rejectWithValue }) => {
    const axiosSession = getGeneralAPIRequest(msSessionInfo);
    const { data, error } = await getBessStatusBySystemId(axiosSession, systemIds);

    if (error) {
      return rejectWithValue(error); 
    }

    return data; 
  }
);

const bessSlice = createSlice({
  name: 'bess',
  initialState: {
    loading: false,
    error: null,
    data: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBessStatusBySystemId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBessStatusBySystemId.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        const newEntries = action.payload;

        // Filter out existing entries based on systemId
        const filtered = state.data.filter(
          existing => !newEntries.some(newItem => newItem.systemId === existing.systemId)
        );

        state.data = [...filtered, ...newEntries];
      })
      .addCase(fetchBessStatusBySystemId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Offline';
      });
  }
});

export default bessSlice.reducer;
